import { render, staticRenderFns } from "./listOwner.vue?vue&type=template&id=441428c6&scoped=true"
import script from "./listOwner.vue?vue&type=script&lang=js"
export * from "./listOwner.vue?vue&type=script&lang=js"
import style0 from "./listOwner.vue?vue&type=style&index=0&id=441428c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441428c6",
  null
  
)

export default component.exports